import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import Accordions from '../Accordions/Accordions';
import PointsList from '../PointsList/PointsList';
import { GatsbyImage } from 'gatsby-plugin-image';
import { styles } from './styles';

export default function PrecourseProgramCard({
  card,
  isMobile,
  pointIcon,
  image,
  cardStyle,
}) {
  const CardContent = () => (
    <>
      {card.points && <Points points={card.points} pointIcon={pointIcon} />}
      {card.description && (
        <Typography variant="desktopP2" mt={2} color={'kit.text.secondary'}>
          {card.description}
        </Typography>
      )}
      {card.resultTitle && (
        <>
          <Typography
            variant="desktopH5"
            sx={{ color: 'kit.text.h', mt: { xs: 2, md: 3 } }}
          >
            {card.resultTitle}
          </Typography>
          <Points points={card.resultPoints} pointIcon={pointIcon} />
        </>
      )}
      {image && !isMobile && (
        <GatsbyImage
          image={image}
          alt="img"
          style={{ width: 264, marginTop: 16 }}
        />
      )}
    </>
  );

  return (
    <Box sx={cardStyle || styles.root}>
      {isMobile ? (
        <Accordions
          sx={styles.accordions(card.isLastCard)}
          summary={<DayPlate day={card.day} />}
          details={<CardContent />}
        />
      ) : (
        <Paper
          elevation={0}
          sx={{
            ...styles.paper,
            backgroundColor: card.isLastCard
              ? 'kit.background.middlepurple'
              : 'kit.background.white',
          }}
        >
          <DayPlate day={card.day} />
          <CardContent />
        </Paper>
      )}
    </Box>
  );
}

const DayPlate = ({ day }) => (
  <Paper elevation={0} sx={styles.day}>
    <Typography
      variant={isMobile ? 'mobileH3' : 'desktopH4'}
      color={'kit.text.mainInverse'}
    >
      {day}
    </Typography>
  </Paper>
);

const Points = ({ points, pointIcon }) => (
  <Box sx={{ mt: 2 }}>
    <PointsList list={points} pointIcon={pointIcon} textProps={styles.points} />
  </Box>
);
